// extracted by mini-css-extract-plugin
export var attachment = "_ok-a";
export var emailContainer = "_ok-4";
export var emailContentPaddedContainer = "_ok-b";
export var emailHeader = "_ok-6";
export var emailIframe = "_ok-3";
export var emailInfoIcon = "_ok-9";
export var emailShortenedSummary = "_ok-e";
export var infoDropdown = "_ok-0";
export var infoRowBoundedContent = "_ok-d";
export var internal = "_ok-5";
export var merchant = "_ok-8";
export var messageInputContainer = "_ok-h";
export var normal = "_ok-7";
export var replyCard = "_ok-f";
export var subtleButton = "_ok-1";
export var subtleButtonIconContainer = "_ok-2";
export var toggleViewRepliesButton = "_ok-c";
export var wrappingText = "_ok-g";